// Copyright (c) StrangeBee 2023

import { ReactElement, memo } from 'react';
import { classList } from '@Helpers/className';

import './TextPreview.scss';

interface TextPreviewProps {
    src: string;
    className?: string;
}

export const TextPreview = memo(
    ({ src, className }: TextPreviewProps): ReactElement => (
        <pre className={classList('TextPreview', className)}>{src}</pre>
    ),
);
